// СРЕДНЯЯ ОЦЕНКА — ТОЛЬКО ПО ОЦЕНЁННЫМ ОТЗЫВАМ.
//
// У отзывов-скриншотов оценки нет: в переписке из WhatsApp звёзд не бывает,
// в базе там стоит 0. Раньше такой отзыв входил в среднее как ноль из пяти —
// три скриншота рядом с тремя пятёрками давали «2.5 из 5», то есть сайт сам
// портил себе рейтинг. Теперь считаем только те, где оценка действительно
// проставлена, а если оценённых нет вовсе — возвращаем 0, и блок с рейтингом
// не показывается (см. src/sections/reviews/stats.jsx).
export function calculateAverageStars(reviews) {
    const rated = (reviews || []).filter((review) => Number(review.stars) > 0);
    if (rated.length === 0) {
        return 0;
    }

    const totalStars = rated.reduce((sum, review) => sum + Number(review.stars), 0);

    return (totalStars / rated.length).toFixed(1);
};
